import apiFetch from '../apiFetch'

export default function (token, rating) {
  return apiFetch({ endPoint: `Rating/${rating.ratingId}`, method: 'PUT', body: rating, token: token })
}
